<template>
    <!-- Portfolio section start -->
	<section id="portfolio-section" class="px-4 lg:px-8 py-16  relative">
        <!-- Text wrapper start -->
        <div class="flex gap-8 flex-col md:flex-row">
            <!-- Main text start -->
            <h1 class="uppercase text-5xl mb-4 font-semibold ">
                GALLERY
            </h1>
            
            <!-- Main text end -->
        </div>
        <!-- Text wrapper end -->

        <!-- Images grid start -->
		<div class="grid-cols-2 md:grid-cols-5 grid mb-8 gap-4">
            <div class="grid grid-cols-1 md:hidden gap-4">
                <img src="@/assets/image1.jpg" alt="1" class="rounded-xl">
                <img src="@/assets/image42.jpg" alt="2" class="rounded-xl">
                <img src="@/assets/image13.jpg" alt="3" class="rounded-xl">
                <img src="@/assets/image14.jpg" alt="4" class="rounded-xl">
                <img src="@/assets/image15.jpg" alt="5" class="rounded-xl">
            </div>
            <div class="grid grid-cols-1 md:hidden gap-4">
                <img src="@/assets/image40.jpg" alt="1" class="rounded-xl">
                <img src="@/assets/image41.jpeg" alt="2" class="rounded-xl">
                <img src="@/assets/image44.jpg" alt="3" class="rounded-xl">
                <img src="@/assets/image18.jpg" alt="4" class="rounded-xl">
                <img src="@/assets/image19.jpg" alt="5" class="rounded-xl">
            </div>

            <div class="hidden md:flex flex-col gap-4">
                <img src="@/assets/image1.jpg" alt="1" class="rounded-xl">
                <img src="@/assets/image41.jpeg" alt="2" class="rounded-xl">
                
            </div>
            <div class="hidden md:flex flex-col gap-4">
                <img src="@/assets/image15.jpg" alt="1" class="rounded-xl">
                <img src="@/assets/image42.jpg" alt="2" class="rounded-xl">
                
            </div>
            <div class="hidden md:flex flex-col gap-4">
                <img src="@/assets/image14.jpg" alt="1" class="rounded-xl">
                <img src="@/assets/image45.jpeg" alt="2" class="rounded-xl">
               
            </div>
            <div class="hidden md:flex flex-col gap-4">
                <img src="@/assets/image19.jpg" alt="1" class="rounded-xl">
                <img src="@/assets/image48.jpg" alt="2" class="rounded-xl">
              
            </div>
            <div class="hidden md:flex flex-col gap-4">
                <img src="@/assets/image13.jpg" alt="1" class="rounded-xl">
                <img src="@/assets/image15.jpg" alt="2" class="rounded-xl">
           
            </div>
        </div>
		<!-- Images grid end -->

        <!-- "More" link start -->
        <a href="#" class="text-end">
            <p class="font-semibold text-lg group relative">
                <span>Show more photos </span>
                <i class="fa-solid fa-arrow-right"></i>
            </p>
        </a>
        <!-- "More" link end -->

        <!-- Circle start -->
        <div class="bg-neutral-300 h-64 w-64 rounded-full absolute top-0 left-0 mt-16 -z-20"></div>
        <!-- Circle end -->
	</section>
	<!-- Portfolio section end -->
</template>

<script>
export default {

}
</script>

<style>

</style>